module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_0.afcfbeb8.png";